module.exports = __webpack_public_path__ + "img/bluemetering_mobile.c82eb56d.png";